import { render, staticRenderFns } from "./Inicio.vue?vue&type=template&id=4c64dab8&"
import script from "./Inicio.vue?vue&type=script&lang=js&"
export * from "./Inicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports